<template>
	<div>
		<div class="swiper mySwiper swiper-container item-swiper" ref="itemSwiper">
			<div class="swiper-wrapper">
				<div v-for="slide in listEntries" class="swiper-slide item-swiper__slide">
					<div class="item-swiper__slide-left">
						<img :src="slide.img" :alt="slide.headline">
					</div>
					<div class="item-swiper__slide-right">
						<div class="item-swiper__txt-wrapper">
							<div class="item-swiper__headline">{{ slide.headline }}</div>
							<div class="item-swiper__txt" v-html="slide.text"></div>
						</div>

						<a class="item-swiper__btn" :href="slide.realUrl">{{ slide.buttonText }}</a>
					</div>
				</div>
			</div>
			<div class="swiper-pagination item-swiper__pagination"></div>
			<div class="swiper-button-next item-swiper__next" ref="next"><i class="fa fa-arrow-right" aria-hidden="true"></i></div>
			<div class="swiper-button-prev item-swiper__prev" ref="prev"><i class="fa fa-arrow-left" aria-hidden="true"></i></div>
		</div>
	</div>
</template>

<script>

	import { Swiper } from "swiper"

	export default {

		props: {
			listEntries: [Object, Array],
		},

		mounted(){
			this.initSwiper();
		},
		methods: {
			initSwiper(){
				var swiper = new Swiper(this.$refs.itemSwiper, {
					pagination: {
						el: ".swiper-pagination",
					},

					navigation: {
						nextEl: this.$refs.next,
						prevEl: this.$refs.prev,
					},

				});
			}
		}
	}

</script>
